import initializeBootLocalization from 'mini-boot-localization/lib/initializeBootLocalization';
import { bootstrap as sharedBootstrap } from 'owa-shared-bootstrap';
import { BootstrapOptions } from './types/BootstrapOptions';
import { getWindowTitle } from 'mini-window-title/lib/getWindowTitle';
import { initializeAppState } from './initialization/initializeAppState';
import { initializeTheme } from './initialization/initializeTheme';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { lazySetupSharedPostBoot } from 'mini-shared-post-boot';
import { MiniErrorComponentAsync } from 'mini-error-component';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { SWAppName } from 'mini-app-constants';

// Delay before invoking the post boot function.
const DELAY_AFTER_RENDER_IN_MILLISECONDS = 200;

/**
 * Extend the shared-bootstrap to perform mini specific boot operations
 * @param options
 */
export const bootstrap = (options: BootstrapOptions) =>
    sharedBootstrap({
        ...options,
        initializeState: (sessionData?: SessionData) => {
            const statePromises = [];
            const commonInitPromise = initializeAppState();
            const initializeThemePromise = initializeTheme();
            statePromises.concat([commonInitPromise, initializeThemePromise]);

            const originalPromise = options.initializeState(sessionData);
            if (originalPromise) {
                statePromises.push(originalPromise);
            }
            return Promise.all(statePromises);
        },
        getWindowTitle: () => getWindowTitle(options.getModuleName()),
        initializeLocalization: initializeBootLocalization(options.workload),
        fullErrorComponent: MiniErrorComponentAsync,
    }).then(() => {
        setTimeout(() => {
            const swAppName = isHostAppFeatureEnabled('opxComponentLifecycle')
                ? SWAppName.miniNative
                : null;
            lazySetupSharedPostBoot.importAndExecute({ swAppName });
        }, DELAY_AFTER_RENDER_IN_MILLISECONDS);
    });
